import React, { Component } from 'react';
import { Link } from 'react-router-dom';

//Core Libs
import prd from "../Core/Products";

// Componets
import ProductNode 		from '../Reducer/ProductNode';


class FeaturedProducts extends Component {
    
    constructor(props){
        
        super(props);

        this.state = {
            featuredProducts: {}
        };
        
    }
    
    componentWillMount() {		
		this.getFeaturedProducts();
	}


	getFeaturedProducts = () => {
		
		prd.getFeaturedCycles( (response) => {
			this.setState({
				featuredProducts: response.data
			});
		});

    }
    
    render() {
        
        let featuredProducts = (
			<div className="row">
				{[1, 2, 3, 4, 5, 6].map((item) => (
					<div className="col-xs-12 col-sm-6 col-md-4" key={item}>
						<ProductNode loading={'loading'} />
					</div>
				))}
			</div>
		);

		if(this.state.featuredProducts.length) {
			const count = this.state.featuredProducts.length;
			const visibleProducts = count >= 3
				? this.state.featuredProducts.slice(0, count - (count % 3))
				: this.state.featuredProducts;
			
			featuredProducts = (
				<div className="row">
					{
						visibleProducts.map(function(item, i){
							return(
								<div className="col-xs-12 col-sm-6 col-md-4" key={i}>
									<ProductNode item={item} />
								</div>					
							)
						})
					}
				</div>
			)


        }
        
		return (            
            <section className="container product-container">
                <header className="header header-main row">
                    <h2 className="col-md-12">Populære Cykler</h2>
                    <p className="col-md-12" style={{ color: '#666', fontSize: '16px', marginTop: '-10px', marginBottom: '30px' }}>
                        Håndplukkede kvalitetscykler til skarpe priser – klar til levering i København
                    </p>
                </header>
                    
                {featuredProducts}						

                <div className="text-center" style={{ marginTop: '35px', marginBottom: '20px' }}>
                    <Link to="/cycles" className="btn btn-primary btn-lg">
                        Se Alle Cykler
                    </Link>
                </div>
            </section>
		);
	}
}

export default FeaturedProducts;


// WEBPACK FOOTER //
// ./src/Components/FeaturedProducts.js